"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
class GetProductTariffsResponseProduct extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => offerstore_api_models_1.YearlyMonthlyValue),
    (0, class_validator_1.ValidateNested)(),
    tslib_1.__metadata("design:type", offerstore_api_models_1.YearlyMonthlyValue)
], GetProductTariffsResponseProduct.prototype, "totalPrice", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'E_H_BDZ', description: 'Product ID as set by the Tarif Team' }),
    tslib_1.__metadata("design:type", String)
], GetProductTariffsResponseProduct.prototype, "cdtProductId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(offerstore_api_models_1.ProductType)),
    (0, base_models_1.Docs)({
        example: offerstore_api_models_1.ProductType.ELECTRICITY,
        description: 'Product type. Currently either only electricity or gas.',
    }),
    tslib_1.__metadata("design:type", String)
], GetProductTariffsResponseProduct.prototype, "type", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'E_H_BDZ',
        description: `Name of the product. Currently only SOL products same as the cdtProductId. Which describe the type of contract that is linked to the product.
    For example E_H_BDZ stands for electricity, household, zekerheid/fixed product.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetProductTariffsResponseProduct.prototype, "name", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'ZekerheidsGarantie Elektriciteit Groen',
        description: 'Short decription of the product. Currently set by the Tarif Team',
    }),
    tslib_1.__metadata("design:type", String)
], GetProductTariffsResponseProduct.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => offerstore_api_models_1.PriceGroup),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    tslib_1.__metadata("design:type", Array)
], GetProductTariffsResponseProduct.prototype, "priceGroups", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => offerstore_api_models_1.ConsumptionPrice),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    tslib_1.__metadata("design:type", Array)
], GetProductTariffsResponseProduct.prototype, "consumptionPrices", void 0);
exports.default = GetProductTariffsResponseProduct;
